import { render, staticRenderFns } from "./DrillTable.vue?vue&type=template&id=50d8c1b7&"
import script from "./DrillTable.vue?vue&type=script&lang=ts&"
export * from "./DrillTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports